import filterObject from 'just-filter-object'

type NullableToOptional<T> = {
  [P in keyof T]?: Exclude<T[P], null | undefined | ''>
}

/**
 * 指定したObject が保持してる値が null , undefined, 空文字, 空配列 の場合、その項目を削除
 */
export function filterObjectEmpty<T>(obj: T): NullableToOptional<T> {
  return filterObject(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    obj as any,
    (_, value) =>
      value != null &&
      value !== '' &&
      (Array.isArray(value) ? value.length > 0 : true)
  )
}
